/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { InterestValidator } from "../InterestValidator";

export class InterestValidator__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(_nexus: string, overrides?: Overrides): Promise<InterestValidator> {
    return super.deploy(_nexus, overrides || {}) as Promise<InterestValidator>;
  }
  getDeployTransaction(
    _nexus: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_nexus, overrides || {});
  }
  attach(address: string): InterestValidator {
    return super.attach(address) as InterestValidator;
  }
  connect(signer: Signer): InterestValidator__factory {
    return super.connect(signer) as InterestValidator__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): InterestValidator {
    return new Contract(address, _abi, signerOrProvider) as InterestValidator;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nexus",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "feederPool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interest",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newTotalSupply",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "apy",
        type: "uint256",
      },
    ],
    name: "InterestCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_feeders",
        type: "address[]",
      },
    ],
    name: "collectAndValidateInterest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastBatchCollected",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nexus",
    outputs: [
      {
        internalType: "contract INexus",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
